import { makeStyles } from '@rneui/themed'
import React from 'react'
import { View } from 'react-native'

interface Props {
  children: React.ReactNode
}

export function TileBox({ children }: Props) {
  const styles = useStyles()
  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>{children}</View>
    </View>
  )
}

export const useStyles = makeStyles(theme => ({
  container: {
    borderRadius: 10,
    marginVertical: 5,
    shadowOpacity: 0.3,
    shadowRadius: 5,
    shadowOffset: { width: 2, height: 2 },
    elevation: 5,
    backgroundColor: theme.colors.background,
  },
  innerContainer: {
    overflow: 'hidden',
    borderRadius: 10,
  },
}))
